import { render, staticRenderFns } from "./CTextarea.vue?vue&type=template&id=4705f886&scoped=true&"
import script from "./CTextarea.vue?vue&type=script&lang=ts&"
export * from "./CTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./CTextarea.vue?vue&type=style&index=0&id=4705f886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705f886",
  null
  
)

export default component.exports